import { queryOptions, useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { ChangelogTabs } from "@/components/changelog/changelog-tabs"
import { ServiceForm } from "@/components/changelog/service-form"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { getService } from "@/http/changelog/services"

const serviceQueryOptions = (orgSlug: string, serviceId: string) =>
  queryOptions({
    queryKey: ["changelog-service", orgSlug, serviceId],
    queryFn: async () => {
      const response = await getService({
        serviceId,
        organizationSlug: orgSlug,
      })
      if (response.error) {
        throw new Error(response.error.message)
      }
      return response.data
    },
  })

export const Route = createFileRoute(
  "/_authenticated/$orgSlug/changelog/services/$serviceId/",
)({
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      serviceQueryOptions(params.orgSlug, params.serviceId),
    )
    return {
      title: "Editar serviço",
      path: `/${params.orgSlug}/changelog/services/${params.serviceId}`,
    }
  },
  component: EditServicePage,
})

function EditServicePage() {
  const { orgSlug, serviceId } = Route.useParams()
  const navigate = useNavigate()
  const { data: service } = useSuspenseQuery(
    serviceQueryOptions(orgSlug, serviceId),
  )

  return (
    <div className="space-y-6">
      <ChangelogTabs
        orgSlug={orgSlug}
        serviceId={serviceId}
        activeTab="details"
      />

      <Card>
        <CardHeader>
          <CardTitle>Detalhes do serviço</CardTitle>
          <CardDescription>
            Atualize as informações do serviço{" "}
            <span className="font-semibold">{service.name}</span>.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ServiceForm
            serviceId={serviceId}
            organizationSlug={orgSlug}
            defaultValues={{
              name: service.name,
              slug: service.slug,
              description: service.description ?? undefined,
              isPublic: service.isPublic,
            }}
            onSuccess={() =>
              navigate({
                to: "/$orgSlug/changelog",
                params: { orgSlug },
              })
            }
          />
        </CardContent>
      </Card>
    </div>
  )
}
